/**
 * @fileoverview 空状态组件
 * @description 当列表为空时显示的提示组件
 * @module components/common/EmptyState
 */

import { cn } from '../../lib/utils';

/**
 * 空状态组件属性
 */
interface EmptyStateProps {
  /** 图标（emoji 或组件） */
  icon?: React.ReactNode;
  /** 主标题 */
  title: string;
  /** 副标题/描述 */
  description?: string;
  /** 操作按钮 */
  action?: React.ReactNode;
  /** 额外的容器类名 */
  className?: string;
}

/**
 * 空状态展示组件
 * 用于列表为空、无数据等场景
 */
export default function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-16 text-center', className)}>
      {icon && <div className="text-4xl mb-4 opacity-50">{icon}</div>}
      <h3 className="text-base font-semibold text-foreground mb-1">{title}</h3>
      {description && <p className="text-sm text-muted-foreground max-w-xs">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
